import { useEffect } from "react";

const useNotificationSound = () => {
  const notificationSound = new Audio("/audio/notification.mp3");

  const playNotificationSound = async (message) => {
    new window.Notification("Новое сообщение!", {
      body: message,
      icon: "/icon.png",
    });
    await notificationSound.play();
    notificationSound.currentTime = 0;
  };

  useEffect(() => {
    function showNotification() {
      if (window.Notification && window.Notification.permission === "granted") {
        new window.Notification("Новое сообщение!", {
          body: "У вас новое уведомление.",
          icon: "/icon.png",
        });

        // Параллельно проигрываем звук
        // playNotificationSound().catch(err => {
        //     console.warn("Автовоспроизведение заблокировано:", err);
        // });
      }
    }

    if (window.Notification && window.Notification.permission !== "denied") {
      window.Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          showNotification();
        }
      });
    }
  }, []);

  return { playNotificationSound };
};

export default useNotificationSound;
